// mds-dojo — dojo/when — faithful behavior of references/dojo/when.js: if the value
// is a thenable, attach callback/errback/progback; otherwise call callback
// synchronously with the value and return its result. Used by dojo/Stateful.set to
// defer watch notification until an async setter's promise resolves.
export default function when(valueOrPromise: any, callback?: any, errback?: any, progback?: any): any {
  const receivedPromise = valueOrPromise && typeof valueOrPromise.then === 'function';
  if (!receivedPromise) {
    // not a promise — call callback synchronously
    return callback ? callback(valueOrPromise) : valueOrPromise;
  }
  if (callback || errback || progback) {
    return valueOrPromise.then(callback, errback, progback);
  }
  return valueOrPromise;
}
